import React, {useState , useEffect , Fragment} from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import BB from '../images/BB.png';
import Header from '../Component/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import Footer from '../Component/Footer';
import ProjectHeader from '../Component/ProjectHeader';
import WindowListPopup from '../Component/WindowCountPopup';

function WindowsCustomize() {
    const navigate = useNavigate();
  const location = useLocation();
  const { /* sampleData */ data} = location.state || {};
  console.log(data)
   
  const type = location?.state?.type || {};
  console.log("quotation type received:", type);
const [initialVendors, setInitialVendors] = useState([]);
const [showSaveConfirmPopup, setShowSaveConfirmPopup] = useState(false);
const [hasChanges, setHasChanges] = useState(false);
 //console.log(initialVendors);
 const [showWindowListPopup, setShowWindowListPopup] = useState(false);
const [selectedWindowItem, setSelectedWindowItem] = useState(null);
const[showConfirmPopup, setShowConfirmPopup] = useState(false);
const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
 const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

const defaultUnitTab = selectedWindowItem?.applied_areas?.length > 0 
  ? selectedWindowItem.applied_areas[0].unit_no 
  : null;

const [activeUnitTab, setActiveUnitTab] = useState(defaultUnitTab);


const [items, setItems] = useState([
  {
    item_name: "600x1200mm Glossy ",
    unit_price: 35,
    vendor:  { // Vendor data embedded within each item
      _id: "VEN003",
      name: "Flais",
      image:"",
    }, // Example using your initialVendors data
    attributes: [
      {
        attribute_id: "F001",
        attribute_name: "Finish",
        attribute_value_id: "FG001",
        attribute_value: "Glossy"
      },
      { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "18.5", attribute_value_id: "BS002" }

    ],
    product_subcategory: { name: "600x1200mm", _id: "CT001" }
  },
  {
    item_name: "800x1600mm Glossy",
    unit_price: 42,
    vendor:  { // Vendor data embedded within each item
      _id: "VEN003",
    name: "Flais",
    image:"",
},
    attributes: [
      {
        attribute_id: "F002",
        attribute_name: "Finish",
        attribute_value_id: "FM001",
        attribute_value: "Glossy"
      },
      { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "24.5", attribute_value_id: "BS002" }

      // ... other attributes
    ],
    product_subcategory: { name: "800x1600mm", _id: "PT001" }
  },
  {
    item_name: "1200x1800mm Matt",
    unit_price: 28,
    vendor:  { // Vendor data embedded within each item
      _id: "VEN004",
      name: "Sega ",
      image:"",
    }, // Use data from initialVendors
    attributes: [
      {
        attribute_id: "F003",
        attribute_name: "Finish",
        attribute_value_id: "FR001",
        attribute_value: "Matt"
      },
      { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "18.5", attribute_value_id: "BS002" }
      // ... other attributes as needed
    ],
    product_subcategory: { name: "1200x1800mm", _id: "CT001" } // Example subcategory
  },
  {
    item_name: "800x1600mm Glossy",
    unit_price: 22,
    vendor:  { // Vendor data embedded within each item
      _id: "VEN004",
    name: "Sega ",
    image:"",
},
    attributes: [
      {
        attribute_id: "F004",
        attribute_name: "Finish",
        attribute_value_id: "FS001",
        attribute_value: "Glossy"
      },
      { attribute_id: "B001", attribute_name: "Sq Ft per Box", attribute_value: "24.5", attribute_value_id: "BS002" }
      // ... other attributes
    ],
    product_subcategory: { name: "800x1600mm", _id: "PT001" } // Example
  },
  // ... more items as needed
]);
  //const [vendors, setVendors] = useState(initialVendors);
  const [selectedFinish ,setSelectedFinish] = useState(null);
  const [selectedSubCategory, setSelectedSubcategory] = useState(null);
  //console.log(selectedSubCategory , selectedFinish)
  const [showVendorPopup, setShowVendorPopup] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  //console.log(selectedVendor);
  const [currentVendorIndex, setCurrentVendorIndex] = useState(null); // Store the ID, not the index
  const [showRoomPopup, setShowRoomPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);  // Track the selected item
  const [selectedRooms, setSelectedRooms] = useState({}); // Track selected rooms for each item
  //console.log(selectedRooms);
  const [updatedSampleData, setUpdatedSampleData] = useState(data); // New state for sampleData
console.log("sampleData:", updatedSampleData);
const [unappliedAreas, setUnappliedAreas] = useState([]);
const [deselectedAreas, setDeselectedAreas] = useState([]);
//console.log("deselectedAreas:", deselectedAreas);
//console.log("unappliedAreas:", unappliedAreas);
const [mappedItems,setMappedItems] = useState([]);
const [checkedItems, setCheckedItems] = useState({});
// Initialize with null instead of potentially undefined value
const [currentVendor, setCurrentVendor] = useState(null);
const [showProductSelectionPopup, setShowProductSelectionPopup] = useState(false);
const [deselectedAssets, setDeselectedAssets] = useState([]); // To store deselected asset names
const [selectedProductId, setSelectedProductId] = useState(null);
const [unselectedItems, setUnselectedItems] = useState([]);
const [showComparePopup, setShowComparePopup] = useState(false);


useEffect(() => {
  if (type && type.toLowerCase().includes('customized')) {
    console.log("This is a customized quotation");
    setHasChanges(true);
  } else {
    console.log("This is a standard quotation");
    // Standard handling
  }
}, [type]);

// Add a useEffect to set the current vendor when data is loaded
useEffect(() => {
  if (data && data.items && data.items.length > 0) {
    // Check if vendor_id is an object or a string
    const vendorId = typeof data.items[0].vendor_id === 'object' 
      ? data.items[0].vendor_id._id  // If it's an object, get the _id
      : data.items[0].vendor_id;     // If it's already a string ID
    
    // If vendor is available directly
    const vendorFromItem = data.items[0].vendor?._id;
    
    // Set the current vendor ID
    setCurrentVendor(vendorFromItem || vendorId);
    
    // If vendors are available, you might want to fetch items for the default vendor
    if (data.vendors && Object.keys(data.vendors).length > 0) {
      const defaultVendorId = vendorFromItem || vendorId;
      const defaultVendor = data.vendors[defaultVendorId];
      
      if (defaultVendor && data.product_category_id && data.package_id) {
        // Fetch items for the default vendor
        fetchVendorQuotationItems(
          defaultVendor, 
          data.package_id, 
          data.product_category_id
        );
      }
    }
  }
}, [data]);


// Update activeUnitTab when selectedWindowItem changes
useEffect(() => {
  if (selectedWindowItem?.applied_areas?.length > 0) {
    setActiveUnitTab(selectedWindowItem.applied_areas[0].unit_no);
  } else {
    setActiveUnitTab(null);
  }
}, [selectedWindowItem]);


//comparision data 
const getComparisonData = () => {
  if (!updatedSampleData || !updatedSampleData.vendors || !updatedSampleData.items) {
    return [];
  }
  const itemsBySubcategory = {};
  
  updatedSampleData.items.forEach(item => {
    const subcategoryId = item.product_subcategory?._id;
    const subcategoryName = item.product_subcategory?.name || 'Unknown';
    
    if (!itemsBySubcategory[subcategoryId]) {
      itemsBySubcategory[subcategoryId] = {
        subcategoryName,
        items: {}
      };
    }
    
    // Group by vendor within subcategory
    const vendorId = item.vendor?._id || item.vendor_id;
    if (!itemsBySubcategory[subcategoryId].items[vendorId]) {
      itemsBySubcategory[subcategoryId].items[vendorId] = [];
    }
    
    itemsBySubcategory[subcategoryId].items[vendorId].push(item);
  });
  
  return Object.values(itemsBySubcategory);
};

const parseSpecifications = (specs) => {
  if (!specs) return [];
  
  try {
    if (typeof specs === 'string') {
      const parsed = JSON.parse(specs);
      return Array.isArray(parsed) ? parsed : [];
    }
    return Array.isArray(specs) ? specs : [];
  } catch (e) {
    console.error('Error parsing specifications:', e);
    return [];
  }
};


const getAllSpecKeys = (comparisonData) => {
  const allKeys = new Set();
  
  comparisonData.forEach(category => {
    Object.values(category.items).forEach(vendorItems => {
      vendorItems.forEach(item => {
        const specs = parseSpecifications(item.specifications);
        specs.forEach(spec => {
          // Handle different spec formats
          if (spec.name) {
            allKeys.add(spec.name);
          } else {
            Object.keys(spec).forEach(key => {
              if (key && key.trim() !== '') {
                allKeys.add(key);
              }
            });
          }
        });
      });
    });
  });
  
  return Array.from(allKeys);
};



// Modify the handleItemCheckboxChange function to ensure only one item is selected at a time
const handleItemCheckboxChange = (id) => {
  // Create a new object for checked items
  const newCheckedItems = {};
  
  // First, copy all the current asset selections (but not item selections)
  Object.keys(checkedItems).forEach(key => {
    // If this is an asset ID (not an item ID), preserve its checked state
    if (selectedItem.applied_areas.some(area => area._id === key)) {
      newCheckedItems[key] = checkedItems[key];
    }
  });
  
  // Then set the newly selected item to checked, and uncheck any previously selected items
  newCheckedItems[id] = true;
  
  // Update the checked items state
  setCheckedItems(newCheckedItems);
};



useEffect(() => {
  if (selectedItem) {
    const initialChecked = {};
    
    // Mark the selected item as checked
    initialChecked[selectedItem.item_id || selectedItem._id] = true;
    
    // Mark all applied areas as checked initially
    selectedItem.applied_areas.forEach(area => {
      initialChecked[area._id] = true;
    });
    
    setCheckedItems(initialChecked);

    // Initialize deselectedAssets based on the applied areas
    const allAppliedAreaIds = selectedItem.applied_areas.map(area => area._id);
    setDeselectedAssets(allAppliedAreaIds); // Set deselectedAssets to all applied areas initially
  }
}, [selectedItem]);






const handleVendorChangeClick = (vendorId, vendor, categoryId,packageId) => {
  console.log("packageid:",packageId)
  setCurrentVendor(vendorId);
  fetchVendorQuotationItems(vendor,packageId,categoryId)
  console.log("categoryId:",categoryId)
  //fetchItems(vendor._id,categoryId);
};
  useEffect(() => {
    if (data ) {
      setUpdatedSampleData(data); // Initialize updatedSampleData
    }
  }, [data]);


  const handleWindowCountClick = (item) => {
    setSelectedWindowItem(item);
    setShowWindowListPopup(true);
  };
  
  
  
 
// useEffect hook to call fetchItems when selectedVendor changes
useEffect(() => {
  if (selectedVendor) {
    fetchItems(selectedVendor);
  }
}, [selectedVendor]);

  const fetchItems = async (vendorId,categoryId) => {
    const PCid = updatedSampleData.product_category_id._id;
    console.log(PCid)
    try {
      // Construct the API endpoint URL
      const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/get-items-by-category-and-vendor?product_category_id=${categoryId._id}&vendor_id=${vendorId}`;
  
      // Make the fetch request
      const response = await fetch(url);
  
      // Check if the response is ok
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
  
      // Parse the response as JSON
      const data = await response.json();
     // console.log(updatedSampleData.items)
      console.log(data)

      // Check if updatedSampleData.items and data are available
      if (updatedSampleData.items && data.data) {
        // Create a map of product subcategories to their items
        const subcategoryMap = data.data.reduce((acc, item) => {
          const subcategoryId = item.product_subcategory._id;
          if (!acc[subcategoryId]) {
            acc[subcategoryId] = [];
          }
          acc[subcategoryId].push(item);
          return acc;
        }, {});

        // Map the items with the lowest selling price
        const mappedItems = updatedSampleData.items.map(item => {
          const subcategoryId = item.product_subcategory._id;
          const itemsInSubcategory = subcategoryMap[subcategoryId] || [];

          // Find the item with the lowest selling price in the subcategory
          const lowestPriceItem = itemsInSubcategory.reduce((lowest, current) => {
            return (lowest.selling_price < current.selling_price) ? lowest : current;
          }, itemsInSubcategory[0]);

          // Return the mapped item with the lowest price
          return {
            ...item,
            lowest_price_item: lowestPriceItem
          };
        });

        setMappedItems(mappedItems);

        console.log("mappedItems:",mappedItems)
        setSelectedItem(mappedItems[0]?.lowest_price_item)

      }
      // Handle the retrieved data (Assuming data.data contains the required brands info)
      if (data.success) {
        setItems(data.data);
      } else {
        console.error('Error:', data.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  const fetchVendorQuotationItems = async (vendor, packageId, categoryId) => {
    const PCid = categoryId._id;
    console.log(PCid);
    console.log(vendor);
    
    try {
      // Construct the API endpoint URL
      const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-items-by-package-and-vendor?package_id=${packageId}&vendor_id=${vendor._id}&categoryId=${PCid}`;
  
      // Make the fetch request
      const response = await fetch(url);
  
      // Check if the response is ok
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
  
      // Parse the response as JSON
      const data = await response.json();
      console.log(updatedSampleData);
      console.log(data);
  
      // Add vendors, product_category_id, and project_id from updatedSampleData to data.package
      data.package.vendors = updatedSampleData.vendors; // Add vendors
      data.package.product_category_id = updatedSampleData.product_category_id; // Add product_category_id
      data.package.project_id = updatedSampleData.project_id; // Add project_id
  
      // Map product_subcategory from updatedSampleData.items to data.package.items
      data.package.items = data.package.items.map(item => {
        const matchingSubcategory = updatedSampleData.items.find(subItem => 
          subItem.application_areas.area_name.toLowerCase() === item.application_areas.area_name.toLowerCase() 
        );

        console.log("matching subcategory:-----",matchingSubcategory);
      
        if (matchingSubcategory) {
          return {
            ...item,
            product_subcategory: matchingSubcategory.product_subcategory // Add the product_subcategory
          };
        }
        return item; // Return the item unchanged if no match is found
      });
  
      // Add vendor information to each item
      data.package.items = data.package.items.map(item => {
        return {
          ...item,
          vendor: vendor // Add the vendor to each item
        };
      });
  
      console.log(data.package);
      setUpdatedSampleData(data.package);
  
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };





/*   if (!sampleData) {
    return <div>No data available.</div>; // Handle cases where sampleData is missing
  } */

 

  // Create a set of all unique room names from sampleData.items
  const allRooms = new Set();

  data.items.forEach(item => {
    item.applied_areas.forEach(area => {
      if (area.area_name) {
        allRooms.add(area.area_name);
      }
    });
  });
 
  //console.log([...allRooms]); // To see the unique area names
 
// Create a lookup map for all areas across all items:
const allAreasMap = new Map();
updatedSampleData.items.forEach(item => {
  item.applied_areas.forEach(area => {
    allAreasMap.set(area.area_name, area); // Store area details by area_name
  });
});

// ... inside handleRoomChangeClick ...
const handleRoomChangeClick = (item) => {
  console.log("Selected item:", item);
  const subCategoryId = item?.product_subcategory?._id;
  const vendorId = item?.vendor?._id;
  fetchItemsBySubcategory(vendorId,subCategoryId,item._id)
  setSelectedItem(item);
  //setSelectedFinish(item.attributes.find(attr => attr.attribute_name === "finish"));
  setSelectedSubcategory(item.product_subcategory.name);
  //console.log(item.attributes.find(attr => attr.attribute_name === "finish"));
  const initialSelectedRooms = {};
    // Initialize all rooms first with default values:
  allRooms.forEach(room => {
    const areaInCurrentItem = item.applied_areas.find(area => area.area_name === room);
    const areaData = allAreasMap.get(room) || { _id: null, area_name: room, areaInSft: 0 }; // Default if not found

    initialSelectedRooms[room] = {
      selected: !!areaInCurrentItem, // Selected only if in current item
      _id: areaData._id,
      area_name: areaData.area_name,
      areaInSft: areaData.areaInSft
    };
  });

  setSelectedRooms(initialSelectedRooms);
  //console.log("Initial selected rooms:", initialSelectedRooms);
  setShowRoomPopup(true);
};

const fetchItemsBySubcategory = async (vendorId,subCategoryId,itemId) => {
  console.log(vendorId,subCategoryId,itemId)
  //const PCid = updatedSampleData.product_category_id._id;
  //console.log(PCid)
  try {
    // Construct the API endpoint URL
    const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}product/get-items-by-product-subcategory-and-vendor?product_sub_category_id=${subCategoryId}&vendor_id=${vendorId}&item_id=${itemId}`;

    // Make the fetch request
    const response = await fetch(url);

    // Check if the response is ok
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    // Parse the response as JSON
    const data = await response.json();
    //console.log(updatedSampleData.items)
    console.log(data)

    setItems(data.data)

/*     // Check if updatedSampleData.items and data are available
    if (updatedSampleData.items && data.data) {
      // Create a map of product subcategories to their items
      const subcategoryMap = data.data.reduce((acc, item) => {
        const subcategoryId = item.product_subcategory._id;
        if (!acc[subcategoryId]) {
          acc[subcategoryId] = [];
        }
        acc[subcategoryId].push(item);
        return acc;
      }, {});

      // Map the items with the lowest selling price
      const mappedItems = updatedSampleData.items.map(item => {
        const subcategoryId = item.product_subcategory._id;
        const itemsInSubcategory = subcategoryMap[subcategoryId] || [];

        // Find the item with the lowest selling price in the subcategory
        const lowestPriceItem = itemsInSubcategory.reduce((lowest, current) => {
          return (lowest.selling_price < current.selling_price) ? lowest : current;
        }, itemsInSubcategory[0]);

        // Return the mapped item with the lowest price
        return {
          ...item,
          lowest_price_item: lowestPriceItem
        };
      });

      setMappedItems(mappedItems);

      console.log("mappedItems:",mappedItems)
      setSelectedItem(mappedItems[0]?.lowest_price_item)

    }
    // Handle the retrieved data (Assuming data.data contains the required brands info)
    if (data.success) {
      setItems(data.data);
    } else {
      console.error('Error:', data.message);
    } */
  } catch (error) {
    console.error('Fetch error:', error);
  }
};

const handleRoomChange = () => {
  if (!selectedItem || !selectedFinish || !selectedSubCategory) return;

  // Create a deep copy of the updatedSampleData to avoid direct state mutation
  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));

  // Find the index of the item that matches the selected finish and subcategory
  const matchedItemIndex = newUpdatedSampleData.items.findIndex(item => {
    const hasMatchingSubcategory = item.product_subcategory?.name === selectedSubCategory;
    const hasMatchingFinish = item.attributes?.some(
      attr => attr.attribute_name === "finish" && attr.attribute_value === selectedFinish.attribute_value
    );
    return hasMatchingSubcategory && hasMatchingFinish;
  });

  if (matchedItemIndex !== -1) {
    const matchedItem = newUpdatedSampleData.items[matchedItemIndex];

    // Get the 'Sq Ft per Box' attribute value
    const sqFtPerBoxAttr = matchedItem.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
    const sqFtPerBox = sqFtPerBoxAttr ? parseFloat(sqFtPerBoxAttr.attribute_value) : 1;

    // Get newly selected rooms from UI state
    const newlySelectedRooms = Object.keys(selectedRooms)
      .filter(room => selectedRooms[room].selected)
      .map(room => ({
        _id: selectedRooms[room]._id,
        area_name: selectedRooms[room].area_name,
        areaInSft: selectedRooms[room].areaInSft
      }));

    // Filter out rooms that are already applied to avoid duplication
    const existingRoomIds = new Set(matchedItem.applied_areas.map(area => area._id));
    const uniqueNewRooms = newlySelectedRooms.filter(room => !existingRoomIds.has(room._id));

    // Append unique newly selected rooms to the existing applied_areas
    matchedItem.applied_areas = [...matchedItem.applied_areas, ...uniqueNewRooms];

    // Calculate the total area in square feet
    const totalAreaInSft = matchedItem.applied_areas.reduce((sum, area) => sum + (area.areaInSft || 0), 0);

    // Calculate the quantity based on 'Sq Ft per Box' and round up to the next integer
    const rawQuantity = sqFtPerBox > 0 ? totalAreaInSft / sqFtPerBox : 0;
    matchedItem.quantity = Math.ceil(rawQuantity);

    // Calculate the total price and round up to the next integer
    const rawTotalPrice = matchedItem.quantity * matchedItem.selling_price;
    matchedItem.total = Math.ceil(rawTotalPrice);

    // Remove selected areas from other items to avoid duplication
    uniqueNewRooms.forEach(newArea => {
      newUpdatedSampleData.items.forEach((item, idx) => {
        if (idx !== matchedItemIndex) {
          item.applied_areas = (item.applied_areas || []).filter(area => area._id !== newArea._id);

          // Recalculate quantity and total_price for this item
          const itemTotalAreaInSft = item.applied_areas.reduce((sum, area) => sum + (area.areaInSft || 0), 0);
          const itemSqFtPerBoxAttr = item.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
          const itemSqFtPerBox = itemSqFtPerBoxAttr ? parseFloat(itemSqFtPerBoxAttr.attribute_value) : 1;

          // Round up the quantity to the next integer
          const rawItemQuantity = itemSqFtPerBox > 0 ? itemTotalAreaInSft / itemSqFtPerBox : 0;
          item.quantity = Math.ceil(rawItemQuantity);

          // Round up the total price to the next integer
          const rawItemTotalPrice = item.quantity * item.selling_price;
          item.total = Math.ceil(rawItemTotalPrice);
        }
      });
    });

    // Remove deselected areas from each item's applied_areas and add them to unappliedAreas
    let newUnappliedAreas = [...unappliedAreas];

    newUpdatedSampleData.items.forEach(item => {
      const remainingAreas = [];
      item.applied_areas.forEach(area => {
        const isDeselected = deselectedAreas.some(deselected => deselected._id === area._id);
        if (isDeselected) {
          // Add to unappliedAreas if not already present
          if (!newUnappliedAreas.some(unapplied => unapplied._id === area._id)) {
            newUnappliedAreas.push(area);
          }
        } else {
          remainingAreas.push(area);
        }
      });
      item.applied_areas = remainingAreas;

      // Recalculate quantity and total_price for this item
      const itemTotalAreaInSft = item.applied_areas.reduce((sum, area) => sum + (area.areaInSft || 0), 0);
      const itemSqFtPerBoxAttr = item.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
      const itemSqFtPerBox = itemSqFtPerBoxAttr ? parseFloat(itemSqFtPerBoxAttr.attribute_value) : 1;

      // Round up the quantity to the next integer
      const rawItemQuantity = itemSqFtPerBox > 0 ? itemTotalAreaInSft / itemSqFtPerBox : 0;
      item.quantity = Math.ceil(rawItemQuantity);

      // Round up the total price to the next integer
      const rawItemTotalPrice = item.quantity * item.selling_price;
      item.total = Math.ceil(rawItemTotalPrice);
    });

    // Update the state with the new data
    setUpdatedSampleData(newUpdatedSampleData);
    setUnappliedAreas(newUnappliedAreas);
  }

  // Reset UI state
  setShowRoomPopup(false);
  setSelectedItem(null);
  setSelectedRooms({});
  setSelectedFinish(null);
  setSelectedSubcategory(null);
  setDeselectedAreas([]); // Clear the deselectedAreas array
};



const handleCheckboxChange = (id) => {
  setCheckedItems(prev => {
    const newCheckedItems = {
      ...prev,
      [id]: !prev[id],
    };

    // Update deselectedAssets based on the checkbox state
    if (newCheckedItems[id]) {
      // If it was unchecked and is now being checked, remove from deselectedAssets
      setDeselectedAssets(prev => prev.filter(assetId => assetId !== id));
    } else {
      // If it was checked and is now being unchecked, add to deselectedAssets
      setDeselectedAssets(prev => [...prev, id]);
    }

    return newCheckedItems;
  });
};


const handleConfirmedSave = async () => {
  try {
    // Ensure project_id and product_category_id are set correctly
    const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
    const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

    // Destructure to remove `_id` from the root level
    const { _id, package_id, package_name, ...restSampleData } = updatedSampleData;

    // Filter out items with no applied_areas
    const filteredItems = restSampleData.items?.filter(
      item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
    ) || [];

    // Compose the final data object for request
    const quotationData = {
      ...restSampleData,
      project_id: projectId,
      product_category_id: productCategoryId,
      items: filteredItems,
    };

    const token = sessionStorage.getItem('token');
    const response = await fetch(`${fetchUrl}customer/quotations/save-quotation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(quotationData),
    });

    const data = await response.json();
    if (data.success) {
      console.log('Quotation saved successfully');
      console.log('Quotation Response data:', data);
      console.log('P ', data.data.project_id);
      // Navigate to TilesStandardQuoteDetails screen with quotationId
      navigate('/consumer/app/home', {state:{
        p: data.data.project_id,
      }});
    }
  } catch (error) {
    console.error('Failed to save quotation:', error);
  }
};



const handleSaveQuote = async () => {
  if (type && type.toLowerCase().includes('customized')) {
    setShowSaveConfirmPopup(true);
    return; 
  } else {
    setShowSaveConfirmation(true);
    return; 
  }
};



const handleSaveCopy = async () => {
  try {
    // Ensure project_id and product_category_id are set correctly
    const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
    const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

    // Destructure to remove `_id` from the root level
    const { _id, package_id, package_name, ...restSampleData } = updatedSampleData;

    // Filter out items with no applied_areas
    const filteredItems = restSampleData.items?.filter(
      item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
    ) || [];

    // Compose the final data object for request
    const quotationData = {
      ...restSampleData,
      project_id: projectId,
      product_category_id: productCategoryId,
      items: filteredItems,
    };

    const token = sessionStorage.getItem('token');
    const response = await fetch(`${fetchUrl}customer/quotations/save-quotation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(quotationData),
    });

    const data = await response.json();
    if (data.success) {
      console.log('Quotation saved successfully');
      console.log('Quotation Response data:', data);
console.log('P ', data.data.project_id);
      // Navigate to TilesStandardQuoteDetails screen with quotationId
      navigate('/consumer/app/home', {state:{
        p: data.data.project_id,
      }});
    }
  } catch (error) {
    console.error('Failed to save quotation:', error);
  }
};

const handleReplaceOriginal = async () => {
  try {
    // Ensure project_id and product_category_id are set correctly
    const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
    const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

    // Get the original quotation ID
    const quotationId = updatedSampleData._id.toString().trim();
    console.log('Using quotation ID:', quotationId);

    // Filter out items with no applied_areas
    const filteredItems = updatedSampleData.items?.filter(
      item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
    ) || [];

    // Prepare the update data
    const updateData = {
      project_id: projectId,
      product_category_id: productCategoryId,
      items: filteredItems,
      customer_id: updatedSampleData.customer_id,
      subtotal: updatedSampleData.subtotal,
      tax_amount: updatedSampleData.tax_amount,
      total: updatedSampleData.total,
      status: updatedSampleData.status || 'Draft',
      quotation_type: updatedSampleData.quotation_type || 'Standard',
    };

    const token = sessionStorage.getItem('token');
    
    // Try with the quotation_id in the query params
    const response = await fetch(`${fetchUrl}customer/quotations/update-quotation?quotation_id=${quotationId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify({
        ...updateData,
        quotation_id: quotationId  // Include the ID in the body as well for redundancy
      }),
    });

    // Check if response is ok before parsing JSON
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Server responded with ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    
    if (data.success) {
      console.log('Original quotation updated successfully');
      console.log('Quotation Response data:', data);
      
      // After successful save
      setShowSaveConfirmPopup(false);
      
      // Navigate back to project details
      navigate('/consumer/app/home', {
        state: {
          p: projectId,
        }
      });
    } else {
      console.error('Failed to update quotation:', data.message);
      alert('Failed to update quotation: ' + (data.message || 'Unknown error'));
    }
  } catch (error) {
    console.error('Failed to update quotation:', error);
    alert('An error occurred while updating the quotation: ' + error.message);
  }
};

useEffect(() => {
  if (selectedItem) {
    // Auto-select all asset items when popup opens
    const initialChecked = {};

    // Mark selected item checked
    initialChecked[selectedItem.item_id] = true;

    // Mark all asset checkboxes as selected
    selectedItem.applied_areas.forEach(item => {
      initialChecked[item._id] = true;
    });

    setCheckedItems(initialChecked);
  }
}, [selectedItem]);

const allAssetIds = selectedItem?.applied_areas?.map(item => item._id) || [];
const allSelected = allAssetIds.every(id => checkedItems[id]);
const noneSelected = allAssetIds.every(id => !checkedItems[id]);

/* const handleSaveSelecton = () => {
  console.log("Save Selection clicked");
  if (!selectedItem) {
    console.error("No selected item found");
    return;
  }

  // Create a deep copy of the updatedSampleData to avoid direct state mutation
  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));
  
  // Get the selected item ID from the popup
  const selectedItemId = Object.keys(checkedItems).find(id => 
    id !== selectedItem._id && 
    checkedItems[id] && 
    items.some(item => item._id === id)
  );
  
  console.log("New selected item ID:", selectedItemId);
  
  // Get the selected asset IDs (the ones that are checked)
  const selectedAssetIds = selectedItem.applied_areas
    .filter(area => checkedItems[area._id])
    .map(area => area._id);
  
  // Get the unselected asset IDs (the ones that are not checked)
  const unselectedAssetIds = selectedItem.applied_areas
    .filter(area => !checkedItems[area._id])
    .map(area => area._id);
  
  console.log("Selected asset IDs:", selectedAssetIds);
  console.log("Unselected asset IDs:", unselectedAssetIds);
  
  // Find the index of the current item in the updatedSampleData
  const currentItemIndex = newUpdatedSampleData.items.findIndex(
    item => item._id === selectedItem._id
  );
  
  console.log("Current item index:", currentItemIndex);
  
  if (currentItemIndex !== -1) {
    // Get the current item from the updatedSampleData
    const currentItem = newUpdatedSampleData.items[currentItemIndex];
    
    // Filter the applied_areas to keep only the selected ones
    currentItem.applied_areas = currentItem.applied_areas.filter(
      area => selectedAssetIds.includes(area._id)
    );
    
    // If a new item is selected from the popup
    if (selectedItemId) {
      // Find the selected item in the items array
      const newSelectedItem = items.find(item => item._id === selectedItemId);
      
      if (newSelectedItem) {
        console.log("New selected item:", newSelectedItem);
        
        // Check if this item already exists in updatedSampleData
        const existingItemIndex = newUpdatedSampleData.items.findIndex(
          item => item.item_id === newSelectedItem._id
        );
        
        console.log("Existing item index:", existingItemIndex);
        
        if (existingItemIndex !== -1) {
          // Item exists, update its applied_areas with the unselected assets
          const existingItem = newUpdatedSampleData.items[existingItemIndex];
          
          // Get the unselected areas from the current item
          const unselectedAreas = selectedItem.applied_areas.filter(
            area => unselectedAssetIds.includes(area._id)
          );
          
          console.log("Unselected areas to add to existing item:", unselectedAreas);
          
          // Add the unselected areas to the existing item
          existingItem.applied_areas = [...existingItem.applied_areas, ...unselectedAreas];
        } else {
          // Item doesn't exist, create a new one with the unselected assets
          const unselectedAreas = selectedItem.applied_areas.filter(
            area => unselectedAssetIds.includes(area._id)
          );
          
          console.log("Unselected areas for new item:", unselectedAreas);
          
          // Only create a new item if there are unselected areas
          if (unselectedAreas.length > 0) {
            // Create a new item based on the selected item from the popup
            const newItem = {
              item_id: newSelectedItem._id,
              item_name: newSelectedItem.product_name || newSelectedItem.item_name,
              item_group_id: newSelectedItem.product_group_id || "",
              vendor_id: newSelectedItem.vendor_id?._id || newSelectedItem.vendor?._id,
              item_group_name: "",
              quantity: 0, // Will be calculated below
              selling_price: newSelectedItem.selling_price,
              cost_price: newSelectedItem.cost_price || 0,
              tax_rate: newSelectedItem.GST || 18,
              total_tax_amount: 0, // Will be calculated below
              total: 0, // Will be calculated below
              applied_areas_breakup: [],
              UOM: selectedItem.UOM || "Sq.ft",
              UOM_id: selectedItem.UOM_id,
              tax_type: "GST",
              product_addons: [],
              specifications: newSelectedItem.specifications || "[]",
              application_areas: {
                area_name: selectedItem.application_areas?.area_name || "",
                area: "0", // Will be calculated below
                count: "0", // Will be calculated below
                _id: selectedItem.application_areas?._id || `temp-${Date.now()}`
              },
              applied_areas: unselectedAreas,
              _id: `temp-${Date.now()}`,
              areaInSft: 0, // Will be calculated below
              attributes: newSelectedItem.attributes || [],
              product_subcategory: newSelectedItem.product_subcategory || selectedItem.product_subcategory,
              vendor: newSelectedItem.vendor || {
                _id: newSelectedItem.vendor_id?._id,
                name: newSelectedItem.vendor_id?.name,
                image: newSelectedItem.vendor_id?.image
              }
            };
            
            console.log("Adding new item:", newItem);
            
            // Add the new item to the items array
            newUpdatedSampleData.items.push(newItem);
          }
        }
      }
    }
    
    // Recalculate quantities, areas, and totals for all items
    newUpdatedSampleData.items.forEach(item => {
      // Calculate total area in square feet
      const totalAreaInSft = item.applied_areas.reduce(
        (sum, area) => sum + (parseFloat(area.areaInSft) || 0), 
        0
      );
      
      // Update the item's area
      item.areaInSft = totalAreaInSft;
      
      // Update the application_areas area
      if (item.application_areas) {
        item.application_areas.area = totalAreaInSft.toString();
        
        // Update the count of assets
        item.application_areas.count = item.applied_areas.length.toString();
      }
      
      // Calculate quantity based on UOM
      if (item.UOM === "Sq.ft") {
        item.quantity = totalAreaInSft;
      } else if (item.UOM === "No") {
        item.quantity = item.applied_areas.length;
      }
      
      // Calculate total price and tax
      item.total = Math.ceil(item.quantity * item.selling_price);
      item.total_tax_amount = Math.ceil((item.total * item.tax_rate) / 100);
    });
    
    // Recalculate the overall totals
    const subtotal = newUpdatedSampleData.items.reduce(
      (sum, item) => sum + (item.total || 0), 
      0
    );
    
    const taxAmount = newUpdatedSampleData.items.reduce(
      (sum, item) => sum + (item.total_tax_amount || 0), 
      0
    );
    
    newUpdatedSampleData.subtotal = subtotal;
    newUpdatedSampleData.tax_amount = taxAmount;
    newUpdatedSampleData.total = subtotal + taxAmount - (newUpdatedSampleData.discount || 0) + (newUpdatedSampleData.adjustment || 0);
    
    // Remove any items with no applied areas
    newUpdatedSampleData.items = newUpdatedSampleData.items.filter(
      item => item.applied_areas && item.applied_areas.length > 0
    );
  }
  
  console.log("Updated sample data:", newUpdatedSampleData);
  
  // Update the state with the new data
  setUpdatedSampleData(newUpdatedSampleData);
  
  // Reset UI state
  setShowRoomPopup(false);
  setSelectedItem(null);
  setSelectedRooms({});
  setSelectedFinish(null);
  setSelectedSubcategory(null);
  setDeselectedAreas([]);
  setCheckedItems({});

  // After updating the state, open the product selection popup
  setShowProductSelectionPopup(true);
  setDeselectedAssets(unselectedAssetIds); // Store the deselected asset names
}; */







const handleSaveSelecton = () => {
  console.log("Save Selection clicked");
  if (!selectedItem) {
    console.error("No selected item found");
    return;
  }

  // Get the selected product ID from the radio buttons
  const selectedProductId = Object.keys(checkedItems).find(id => 
    id !== selectedItem._id && 
    checkedItems[id] && 
    items.some(item => item._id === id)
  );
  
  // Get the selected and unselected asset IDs
  const selectedAssetIds = selectedItem.applied_areas
    .filter(area => checkedItems[area._id])
    .map(area => area._id);
  
  const unselectedAssetIds = selectedItem.applied_areas
    .filter(area => !checkedItems[area._id])
    .map(area => area._id);
  
  console.log("Selected asset IDs:", selectedAssetIds);
  console.log("Unselected asset IDs:", unselectedAssetIds);
  
  // Create a deep copy of the updatedSampleData
  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));
  
  // Find the index of the current item
  const currentItemIndex = newUpdatedSampleData.items.findIndex(
    item => item._id === selectedItem._id
  );
  
  if (currentItemIndex !== -1) {
    // Get the current item
    const currentItem = newUpdatedSampleData.items[currentItemIndex];
    
    // If a new product is selected, update the current item
    if (selectedProductId) {
      const newSelectedItem = items.find(item => item._id === selectedProductId);
      
      if (newSelectedItem) {
        // Update the current item with the new product details
        currentItem.item_id = newSelectedItem._id;
        currentItem.item_name = newSelectedItem.product_name || newSelectedItem.item_name;
        currentItem.selling_price = newSelectedItem.selling_price;
        currentItem.cost_price = newSelectedItem.cost_price || 0;
        currentItem.tax_rate = newSelectedItem.GST || 18;
        currentItem.specifications = newSelectedItem.specifications || "[]";
        currentItem.attributes = newSelectedItem.attributes || [];
      }
    }
    
    // Keep only the selected assets in the applied_areas
    currentItem.applied_areas = currentItem.applied_areas.filter(
      area => selectedAssetIds.includes(area._id)
    );
    
    
    
    // If there are unselected assets, prepare to show the product selection popup
    if (unselectedAssetIds.length > 0) {
      // Store the unselected assets for use in the product selection popup
      const unselectedAreas = selectedItem.applied_areas.filter(
        area => unselectedAssetIds.includes(area._id)
      );
      
      // Set the deselected assets for the product selection popup
      setDeselectedAssets(unselectedAssetIds);
      
      // Set the unselected items for the product selection popup
      // This should be all items that match the product subcategory
      setUnselectedItems(items.filter(item => 
        item.product_subcategory._id === selectedItem.product_subcategory._id &&
        item._id !== (selectedProductId || selectedItem.item_id)
      ));
      
      // Update the state with the new data
      setUpdatedSampleData(newUpdatedSampleData);
      
      // Close the room popup
      setShowRoomPopup(false);
      
      // Show the product selection popup
      setShowProductSelectionPopup(true);
      
      // Reset other UI state
      setSelectedItem(null);
      setSelectedRooms({});
      setSelectedFinish(null);
      setSelectedSubcategory(null);
      setDeselectedAreas([]);
      setCheckedItems({});
      
      return; // Exit the function here
    }
  }
  
  // Recalculate quantities, areas, and totals for all items
  newUpdatedSampleData.items.forEach(item => {
    // Calculate total area in square feet
    const totalAreaInSft = item.applied_areas.reduce(
      (sum, area) => sum + (parseFloat(area.areaInSft) || 0), 
      0
    );
    
    // Update the item's area
    item.areaInSft = totalAreaInSft;
    
    // Update the application_areas area
    if (item.application_areas) {
      item.application_areas.area = totalAreaInSft.toString();
    }
    
    // Calculate quantity based on UOM
    if (item.UOM === "Sq.ft") {
      item.quantity = totalAreaInSft;
    } else if (item.UOM === "No") {
      item.quantity = item.applied_areas.length;
    }
    
    // Calculate total price and tax
    item.total = Math.ceil(item.quantity * item.selling_price);
    item.total_tax_amount = Math.ceil((item.total * item.tax_rate) / 100);
  });
  
  // Remove any items with no applied areas
  newUpdatedSampleData.items = newUpdatedSampleData.items.filter(
    item => item.applied_areas && item.applied_areas.length > 0
  );
  
  // Recalculate the overall totals
  const subtotal = newUpdatedSampleData.items.reduce(
    (sum, item) => sum + (item.total || 0), 
    0
  );
  
  const taxAmount = newUpdatedSampleData.items.reduce(
    (sum, item) => sum + (item.total_tax_amount || 0), 
    0
  );
  
  newUpdatedSampleData.subtotal = subtotal;
  newUpdatedSampleData.tax_amount = taxAmount;
  newUpdatedSampleData.total = subtotal + taxAmount - (newUpdatedSampleData.discount || 0) + (newUpdatedSampleData.adjustment || 0);
  
  // Update the state with the new data
  setUpdatedSampleData(newUpdatedSampleData);
  
  // Reset UI state
  setShowRoomPopup(false);
  setSelectedItem(null);
  setSelectedRooms({});
  setSelectedFinish(null);
  setSelectedSubcategory(null);
  setDeselectedAreas([]);
  setCheckedItems({});
  
  // Set hasChanges to true
  setHasChanges(true);
};





// const handleApplySelectedProduct = (selectedProductId) => {
//   console.log("selected product id:", selectedProductId);
  
//   if (!selectedProductId || deselectedAssets.length === 0) {
//     setShowProductSelectionPopup(false);
//     return;
//   }
  
//   // Create a deep copy of the updatedSampleData
//   const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));
  
//   // Find the selected product
//   const selectedProduct = items.find(item => item._id === selectedProductId);
  
//   if (!selectedProduct) {
//     console.error("Selected product not found");
//     setShowProductSelectionPopup(false);
//     return;
//   }
  
//   // Check if there's already an item with this product
//   const existingItemIndex = newUpdatedSampleData.items.findIndex(
//     item => item.item_id === selectedProductId
//   );
  
//   if (existingItemIndex !== -1) {
//     // If the product already exists, add the deselected areas to it
//     const existingItem = newUpdatedSampleData.items[existingItemIndex];
    
//     // Find the deselected areas from all items
//     const deselectedAreas = [];
//     newUpdatedSampleData.items.forEach(item => {
//       const areas = item.applied_areas.filter(area => 
//         deselectedAssets.includes(area._id)
//       );
      
//       if (areas.length > 0) {
//         // Remove these areas from the original item
//         item.applied_areas = item.applied_areas.filter(area => 
//           !deselectedAssets.includes(area._id)
//         );
        
//         // Add them to our collection
//         deselectedAreas.push(...areas);
//       }
//     });
    
//     // Add the deselected areas to the existing item
//     existingItem.applied_areas = [...existingItem.applied_areas, ...deselectedAreas];
    
//     // Update the count
//     if (existingItem.application_areas) {
//       existingItem.application_areas.count = existingItem.applied_areas.length.toString();
//     }
//   } else {
//     // If the product doesn't exist, create a new item
//     // Find the deselected areas from all items
//     const deselectedAreas = [];
//     newUpdatedSampleData.items.forEach(item => {
//       const areas = item.applied_areas.filter(area => 
//         deselectedAssets.includes(area._id)
//       );
      
//       if (areas.length > 0) {
//         // Remove these areas from the original item
//         item.applied_areas = item.applied_areas.filter(area => 
//           !deselectedAssets.includes(area._id)
//         );
        
//         // Add them to our collection
//         deselectedAreas.push(...areas);
//       }
//     });
    
//     if (deselectedAreas.length > 0) {
//       // Create a new item based on the selected product
//       const newItem = {
//         _id: `temp-${Date.now()}`,
//         item_id: selectedProduct._id,
//         item_name: selectedProduct.product_name || selectedProduct.item_name,
//         item_group_id: selectedProduct.product_group_id || "",
//         vendor_id: selectedProduct.vendor_id?._id || selectedProduct.vendor?._id,
//         selling_price: selectedProduct.selling_price,
//         cost_price: selectedProduct.cost_price || 0,
//         tax_rate: selectedProduct.GST || 18,
//         specifications: selectedProduct.specifications || "[]",
//         attributes: selectedProduct.attributes || [],
//         UOM: "Sq.ft", // Default UOM
//         tax_type: "GST",
//         applied_areas: deselectedAreas,
//         application_areas: {
//           area_name: deselectedAreas[0].area_name || deselectedAreas[0].room_name,
//           count: deselectedAreas.length.toString(),
//           _id: `temp-${Date.now()}`
//         },
//         product_subcategory: selectedProduct.product_subcategory
//       };
      
//       // Add the new item to the items array
//       newUpdatedSampleData.items.push(newItem);
//     }
//   }
  
//   // Recalculate quantities, areas, and totals for all items
//   newUpdatedSampleData.items.forEach(item => {
//     // Calculate total area in square feet
//     const totalAreaInSft = item.applied_areas.reduce(
//       (sum, area) => sum + (parseFloat(area.areaInSft) || 0), 
//       0
//     );
    
//     // Update the item's area
//     item.areaInSft = totalAreaInSft;
    
//     // Update the application_areas area
//     if (item.application_areas) {
//       item.application_areas.area = totalAreaInSft.toString();
//     }
    
//     // Calculate quantity based on UOM
//     if (item.UOM === "Sq.ft") {
//       item.quantity = totalAreaInSft;
//     } else if (item.UOM === "No") {
//       item.quantity = item.applied_areas.length;
//     }
    
//     // Calculate total price and tax
//     item.total = Math.ceil(item.quantity * item.selling_price);
//     item.total_tax_amount = Math.ceil((item.total * item.tax_rate) / 100);
//   });
  
//   // Remove any items with no applied areas
//   newUpdatedSampleData.items = newUpdatedSampleData.items.filter(
//     item => item.applied_areas && item.applied_areas.length > 0
//   );
  
//   // Recalculate the overall totals
//   const subtotal = newUpdatedSampleData.items.reduce(
//     (sum, item) => sum + (item.total || 0), 
//     0
//   );
  
//   const taxAmount = newUpdatedSampleData.items.reduce(
//     (sum, item) => sum + (item.total_tax_amount || 0), 
//     0
//   );
  
//   newUpdatedSampleData.subtotal = subtotal;
//   newUpdatedSampleData.tax_amount = taxAmount;
//   newUpdatedSampleData.total = subtotal + taxAmount - (newUpdatedSampleData.discount || 0) + (newUpdatedSampleData.adjustment || 0);
  
//   // Update the state with the new data
//   setUpdatedSampleData(newUpdatedSampleData);
  
//   // Close the popup
//   setShowProductSelectionPopup(false);
  
//   // Reset state
//   setDeselectedAssets([]);
//   setSelectedProductId(null);
  
//   // Set hasChanges to true
//   setHasChanges(true);
// };




/* // Function to apply the selected product to the deselected asset names
const handleApplySelectedProduct = (selectedProductId) => {
  if (!selectedProductId) {
    console.error("No product selected");
    return;
  }

  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));

  // Find the deselected assets and apply the selected product
  deselectedAssets.forEach(assetId => {
    const asset = newUpdatedSampleData.items.find(item => item.applied_areas.some(area => area._id === assetId));
    if (asset) {
      // Apply the selected product to the asset
      asset.applied_areas.push({
        _id: assetId,
        area_name: "New Area", // You can customize this as needed
        areaInSft: 0 // Set the area in square feet as needed
      });
    }
  });

  // Update the state with the new data
  setUpdatedSampleData(newUpdatedSampleData);
  setShowProductSelectionPopup(false); // Close the popup
}; */


{/*const handleApplySelectedProduct = (selectedProductId) => {
  console.log("selected product id:", selectedProductId);
  console.log("updatedSampleData:", updatedSampleData);

  if (!selectedProductId) {  
    console.error("No product selected");
    return;
  }

  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));

  console.log("newUpdatedSampleData:", newUpdatedSampleData);

  let selectedProduct = newUpdatedSampleData.items.find(item => item.item_id === selectedProductId);


  console.log("selectedProduct:", selectedProduct);

  if (!selectedProduct) {
    const originalProduct = items.find(item => item._id === selectedProductId);
    if (!originalProduct) {
      console.error("Original product not found");
      return;
    }

    console.log("originalProduct:", originalProduct);

    const foundItem = newUpdatedSampleData.items.find(item => 
      item.product_subcategory.name.toLowerCase() === originalProduct.product_subcategory.name.toLowerCase()
    );
    
    let application_areas;
    if (foundItem) {
       application_areas = foundItem.application_areas;
    }

    console.log("application_areas:",application_areas)


    selectedProduct = {
      ...originalProduct,
      applied_areas: [],
      quantity: 0,
      total: 0,
      total_tax_amount: 0,
      application_areas: application_areas
    };
  }

  const deselectedAreas = updatedSampleData.items.reduce((acc, item) => {
    return [...acc, ...item.applied_areas.filter(area => deselectedAssets.includes(area._id))];
  }, []);

  selectedProduct.applied_areas = [
    ...selectedProduct.applied_areas,
    ...deselectedAreas
  ];

  const totalAreaInSft = selectedProduct.applied_areas.reduce((sum, area) => sum + (area.areaInSft || 0), 0);
  selectedProduct.areaInSft = totalAreaInSft;

  selectedProduct.application_areas.count = selectedProduct.applied_areas.length;

  if (selectedProduct.UOM === "Sq.ft") {
    selectedProduct.quantity = totalAreaInSft;
  } else if (selectedProduct.UOM === "No") {
    selectedProduct.quantity = selectedProduct.applied_areas.length;
  }

  selectedProduct.total = Math.ceil(selectedProduct.quantity * selectedProduct.selling_price);
  selectedProduct.total_tax_amount = Math.ceil((selectedProduct.total * (selectedProduct.GST || selectedProduct.IGST)) / 100);

  console.log("selectedProduct:", selectedProduct);

  const transformedProduct = {
    item_name: selectedProduct.product_name,
    item_id: selectedProduct._id,
    item_group_id: selectedProduct.product_group_id,
    item_group_name: selectedProduct.product_group_name || "",
    applied_areas: selectedProduct.applied_areas,
    quantity: selectedProduct.quantity,
    total: selectedProduct.total,
    total_tax_amount: selectedProduct.total_tax_amount,
    application_areas: selectedProduct.application_areas,
    areaInSft: selectedProduct.areaInSft,
    UOM_id:selectedProduct.UOM_id,
    selling_price:selectedProduct.selling_price,
    cost_price:selectedProduct.cost_price,
    specifications:selectedProduct.specifications,
    tax_rate:selectedProduct.GST || selectedProduct.IGST,
    tax_type:"GST" || "IGST",

  };

  if (!newUpdatedSampleData.items.some(item => item.item_id === transformedProduct.item_id)) {
    newUpdatedSampleData.items.push(transformedProduct);
  }

  setUpdatedSampleData(newUpdatedSampleData);
  setShowProductSelectionPopup(false); 
};*/}

console.log(updatedSampleData)




  return (
    <div className="min-h-screen flex flex-col p-0"> 
    <Header />

   <div className="sticky top-0 z-20 bg-white">
     <ProjectHeader 
        projectName={data?.project_id?.projectName}
        type={'Customizing Quote'}
        categoryName={data?.customized_by 
          ? data.quotation_number 
          : (data?.product_category_id?.product_category_name|| data?.quotation_number)
        }
        buildcoins={
      data?.buildcoins && Array.isArray(data.buildcoins)
        ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
        : 0
    }
      />
  
      {data?.customized_by && (
        <div className="bg-green-50 px-4 py-3 border-b border-green-100 mb-4">
          <p className="flex items-center justify-center text-md text-gray">
            <span className="font-regular">Customized Quotation : </span>
            <span className="ml-1 font-bold text-lg">{data.quotation_number}</span>
          </p>
        </div>
      )}
    </div>


<div className="border-b border-gray-200 mb-1"></div>

<div className="flex flex-col mb-4 mx-2">
  <div className="flex items-start ml-2 mb-2">
    <h2 className="text-lg font-semibold mt-2 mb-2">Choose Windows Brand</h2>
  </div>
 
  
  {/* Scroll container with overflow-x-auto for horizontal scrolling */}
  <div className="relative mx-2">
  {/* Horizontal scrollable container with hidden scrollbar using Tailwind arbitrary values */}
  <div className="flex overflow-x-auto pb-2 snap-x snap-mandatory [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
    {updatedSampleData?.vendors && Object.entries(updatedSampleData.vendors).map(([vendorId, vendor], index) => (
      <div
        key={vendorId}
        className="border p-2 rounded-md shadow-sm relative aspect-square w-24 flex-shrink-0 cursor-pointer hover:border-gray-400 transition-colors mr-3 snap-start"
        onClick={() => handleVendorChangeClick(vendorId, vendor, updatedSampleData?.product_category_id, updatedSampleData.package_id)}
      >
        {/* Selected vendor indicator with improved checkmark */}
        {(currentVendor === vendorId || vendor._id === currentVendor) && (
          <span className="absolute top-1 right-1 bg-red-500 rounded-full w-4 h-4 flex items-center justify-center text-white text-xs">
            ✓
          </span>
        )}
        
        {/* Vendor image and name stacked vertically for square layout */}
        <div className="flex flex-col items-center justify-center h-full">
          <img
            src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${vendor.image}`}
            alt={vendor.name}
            className="h-12 w-12 object-contain mb-1"
          />
          <p className="font-medium uppercase text-xs text-center">{vendor.name}</p>
        </div>
      </div>
    ))}
    
    
  </div>
  
 
  
  <div className="flex items-center justify-center space-x-1 mt-3">
  {updatedSampleData?.vendors && Object.entries(updatedSampleData.vendors).map(([vendorId, vendor], index) => (
    <div
      key={`indicator-${vendorId}`}
      className={`h-2 w-2 rounded-full ${
        (currentVendor === vendorId || vendor._id === currentVendor) 
          ? 'bg-red-500' 
          : 'bg-gray-300'
      }`}
    />
  ))}
</div>


<div className="flex justify-end">
    <button 
      className="bg-white border border-red-500 text-red-500 text-xs font-medium px-2 py-1 rounded-full shadow-sm hover:bg-red-50 transition-colors"
      onClick={() => setShowComparePopup(true)}
      >
      Compare
    </button>
  </div>

</div>

</div>


<div className="border-b border-gray-200 mt-1"></div>






{/* Windows Selections Div starts */}
<div className="mt-1 mb-20 p-2"> {/* Windows Selections */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0.1"> {/* Reduced gap further */}
    {updatedSampleData.items
      .filter(item => item.applied_areas && item.applied_areas.length > 0)
      .map((item) => (
        <div key={item.vendor_id + item.item_name} className="mb-1"> {/* Added small bottom margin */}
          <div className="p-3"> {/* Reduced padding further */}
            {/* Header section with area name and window count */}
            <div className='flex justify-between items-center mb-2'>
              <div className="text-red-500 text-lg font-bold truncate max-w-[160px]">
                {item?.application_areas?.area_name}
              </div>
              <div 
  className='text-xs text-blue-700 font-bold cursor-pointer hover:underline'
  onClick={() => handleWindowCountClick(item)}
>
  {item?.application_areas?.count} Windows
</div>            </div>
            
            {/* Item name section with area text */}
            <div className='flex items-center mb-2'>
              <span className="text-[#C20C0C] mr-1">✓</span>
              <div>
                <h5 className="text-base font-semibold inline">{item.item_name || item.product_name}</h5>
                {/* <span className="text-xs text-gray-500 ml-1">({item.areaInSft} sq.ft)</span> */}
              </div>

            </div>
            
            {/* Specifications section */}
            <div className="mb-2"> {/* Reduced margin */}
            {(() => {
    // Try to parse specifications if it's a string
    let specs = item.specifications;
    if (typeof specs === 'string') {
      try {
        specs = JSON.parse(specs);
      } catch (e) {
        specs = [];
      }
    }
    
    // Check if specs is empty array or contains only empty objects
    const hasValidSpecs = Array.isArray(specs) && specs.length > 0 && 
      specs.some(spec => {
        // Check if it's an empty object or has empty key/value pairs
        if (typeof spec !== 'object' || spec === null) return true;
        
        // Check for name/value format
        if (spec.name && spec.value) return true;
        
        // Check for key-value format
        const keys = Object.keys(spec);
        if (keys.length === 0) return false;
        
        // Check if any key has a non-empty value
        return keys.some(key => spec[key] && spec[key].toString().trim() !== '');
      });
    
    if (hasValidSpecs) {
      return (
        <ul className="list-disc pl-5 space-y-0.5">
          {specs.map((spec, index) => {
            // Handle object with name/value properties
            if (spec.name && spec.value) {
              return (
                <li key={index} className="text-sm text-gray-700">
                  <span className="font-medium">{spec.name}:</span> {spec.value}
                </li>
              );
            }
            
            // Handle object with key-value pairs like {"Size(W*H)": "60mm*58mm"}
            const key = Object.keys(spec)[0];
            const value = spec[key];
            if (key && value && key.trim() !== '' && value.toString().trim() !== '') {
              return (
                <li key={index} className="text-sm text-gray-700">
                  <span className="font-medium">{key}:</span> {value}
                </li>
              );
            }
            
            // Skip empty objects or objects with empty values
            return null;
          }).filter(item => item !== null)} {/* Filter out null items */}
        </ul>
      );
    } else {
      return <p className="text-sm text-gray-500 ml-4">No specifications available.</p>;
    }
  })()}


</div>

            
            {/* Change button section - moved up */}
            <div className="flex justify-end -mt-8 "> {/* Negative margin to move up */}
              <button
                onClick={() => handleRoomChangeClick(item)}
                className="text-[#C20C0C] text-xs font-medium px-2 py-0.5 border border-[#C20C0C] rounded-full hover:bg-gray-100"
              >
                Change
              </button>
            </div>
            
            {/* Light gray border with minimal spacing */}
            <div className='border-t border-gray-200 mt-4'></div> {/* Reduced margin */}
          </div>
        </div>
      ))}
  </div>
  </div>


      {/* Windows Selections Div ends */}

 {/* Room Popup */}
{showRoomPopup && (
  <>
    {/* Overlay - semi-transparent background */}
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowRoomPopup(false)}></div>
    
    {/* Popup - decreased size with more rounded top edges */}
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-xl p-4 z-50 rounded-t-3xl border-t border-l border-r border-gray-300 max-w-md mx-auto">
      {/* Header with title and close button - increased title size */}
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-bold text-gray-800">Select a window type to apply</h3>
        <button
          onClick={() => setShowRoomPopup(false)}
          className="text-red-500 font-bold text-lg hover:bg-red-50 rounded-full h-8 w-8 flex items-center justify-center"
        >
          &times;
        </button>
      </div>
      
      {/* Room name with apply button on right - decreased font size */}
      <div className="flex justify-between items-center mb-3">
        <div className="text-base text-red-500 font-semibold">{selectedItem?.application_areas?.area_name}</div>
        <button
          onClick={() => handleSaveSelecton()}
          className="border border-red-500 text-red-500 px-4 py-1 rounded-full text-sm font-medium hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!Object.keys(checkedItems).some(id =>
            items.some(item => item._id === id && checkedItems[id])
          )}
        >
          Apply
        </button>
      </div>
      
      {/* Divider */}
      <div className="h-px bg-gray-200 w-full mb-3"></div>
      
      {/* Display all items in a single list with consistent order */}
      <div className="pb-2 max-h-[40vh] overflow-y-auto">
        {items
          .filter(item => item.product_subcategory._id === selectedItem?.product_subcategory._id)
          .map(item => {
            const isCurrentlySelected = item._id === selectedItem?.item_id;
            const isChecked = checkedItems[item._id] || false;
            
            return (
              <div
                key={item._id}
                className={`flex items-start mb-2 p-2 rounded-lg ${
                  isCurrentlySelected ? 'bg-gray-50 border border-gray-200' : 'hover:bg-gray-50 border border-gray-200'
                } cursor-pointer`}
                onClick={() => handleItemCheckboxChange(item._id)}
              >
                {/* Standard radio button without checkmark */}
              <div className="relative flex-shrink-0 mt-1">
  <input
    type="radio"
    checked={isChecked}
    onChange={(e) => {
      e.stopPropagation();
      handleItemCheckboxChange(item._id);
    }}
    className="appearance-none w-4 h-4 border border-gray-300 rounded-full checked:border-red-500 focus:outline-none"
  />
  {isChecked && (
    <div className="absolute top-0 left-0 right-0 bottom-0 mb-1 flex items-center justify-center pointer-events-none">
      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
    </div>
  )}
</div>


                
                <div className="ml-2">
                  <div className="font-medium text-sm">{item.product_name}</div>
                  <div className={`text-xs ${isCurrentlySelected ? 'text-blue-700' : 'text-gray-500'}`}>
                    {isCurrentlySelected ? `${selectedItem?.application_areas?.count} Windows` : '0 Windows'}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  </>
)}





{/* Render the product selection popup*/}
{/* {showProductSelectionPopup && (
  <>
  
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowProductSelectionPopup(false)}></div>
    
  
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-xl border-t border-l border-r border-gray-300 p-5 z-50 rounded-t-2xl">
      <div className='flex flex-row justify-between items-center mb-4'>
        <h3 className="text-lg font-bold text-gray-800">Select A Window Type To Apply</h3>
        <button 
          onClick={() => setShowProductSelectionPopup(false)}
          className="text-red-500 font-bold text-lg hover:bg-red-50 rounded-full h-8 w-8 flex items-center justify-center"
        >
          &times;
        </button>
      </div>
      
      {console.log("unselected items:", unselectedItems)}
      
      <div className="mt-2 mb-4">
        {unselectedItems.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No items available for selection.</p>
        ) : (
          <div className="space-y-3">
            {unselectedItems.map(item => (
              <div key={item._id} className="flex items-center p-2 hover:bg-gray-50 rounded-lg">
                <div className="relative flex-shrink-0">
                  <input
                    type="radio"
                    checked={selectedProductId === item._id}
                    onChange={() => setSelectedProductId(item._id)}
                    className="appearance-none w-5 h-5 border border-red-500 rounded-full checked:bg-red-500"
                  />
                  {selectedProductId === item._id && (
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <svg className="w-3 h-3 text-white" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 8L7 11L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  )}
                </div>
                <span className="ml-3 font-medium">{item.product_name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="flex justify-start">
        <button 
          onClick={() => handleApplySelectedProduct(selectedProductId)} 
          className="border border-red-500 text-red-500 px-6 py-1 rounded-full font-medium hover:bg-red-50 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={!selectedProductId}
        >
          Apply
        </button>
      </div>
    </div>
  </>
)} */}

{showSaveConfirmPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center">
    <div className="bg-white rounded-t-xl p-6 w-full max-w-md shadow-xl">
      <div className="text-center mb-4">
        <p className="text-gray-700 text-md mb-2">You have made changes in your quotation</p>
        <p className="text-black font-semibold mb-4 text-md">Would you like to</p>
      </div>
      
      <div className="space-y-3">
        <button 
          onClick={handleReplaceOriginal}
          className="w-full py-3 px-4 bg-red-50 text-[#C20C0C] border border-[#C20C0C] rounded-lg font-medium hover:bg-red-100 transition-colors"
        >
          Replace original quotation
        </button>
        
        <button 
          onClick={handleSaveCopy}
          className="w-full py-3 px-4 bg-red-50 text-[#C20C0C] border border-[#C20C0C] rounded-lg font-medium hover:bg-red-100 transition-colors"
        >
          Save a copy of updated quotation
        </button>
        
        <button 
          onClick={() => setShowSaveConfirmPopup(false)}
          className="w-full py-3 px-4 bg-red-50 text-[#C20C0C] border border-[#C20C0C] rounded-lg font-medium hover:bg-red-100 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

{showComparePopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex flex-col">
    <div className="bg-white rounded-t-xl shadow-xl p-4 flex-1 overflow-hidden flex flex-col max-h-[90vh]">
      {/* Header with close button */}
      <div className="flex justify-between items-center mb-4 sticky top-0 bg-white z-10 pb-2 border-b">
        <h3 className="text-lg font-bold">Compare Windows</h3>
        <button
          onClick={() => setShowComparePopup(false)}
          className="text-gray-500 hover:text-red-500 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      {/* Scrollable content */}
      <div className="flex-1 overflow-y-auto">
        {getComparisonData().map((category, categoryIndex) => (
          <div key={categoryIndex} className="mb-6">
            <h4 className="text-md font-semibold mb-2 sticky left-0 bg-white">{category.subcategoryName}</h4>
            
            {/* Horizontal scrollable table */}
            <div className="overflow-x-auto pb-2">
              <table className="min-w-full border-collapse">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sticky left-0 bg-gray-50 border-b border-r">
                      Specifications
                    </th>
                    {updatedSampleData.vendors.map((vendor, index) => (
                      <th key={vendor._id} className="py-2 px-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r min-w-[180px]">
                        <div className="flex items-center">
                          <img 
                            src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${vendor.image}`} 
                            alt={vendor.name}
                            className="h-5 w-5 mr-2 object-contain"
                          />
                          {vendor.name}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {/* Basic info row - Price */}
                  <tr>
                    <td className="py-2 px-3 text-sm font-medium text-gray-900 sticky left-0 bg-white border-r">
                      Price (per sq.ft)
                    </td>
                    {updatedSampleData.vendors.map((vendor) => {
                      const vendorItems = category.items[vendor._id] || [];
                      const item = vendorItems[0]; // Get first item for this vendor
                      
                      return (
                        <td key={vendor._id} className="py-2 px-3 text-sm text-gray-500 border-r">
                          {item ? `₹${item.selling_price}` : 'N/A'}
                        </td>
                      );
                    })}
                  </tr>
                  
                  {/* Get all specification keys and create rows */}
                  {getAllSpecKeys(getComparisonData()).map((specKey, specIndex) => (
                    <tr key={specIndex} className={specIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                      <td className="py-2 px-3 text-sm font-medium text-gray-900 sticky left-0 bg-inherit border-r">
                        {specKey}
                      </td>
                      {updatedSampleData.vendors.map((vendor) => {
                        const vendorItems = category.items[vendor._id] || [];
                        const item = vendorItems[0]; // Get first item for this vendor
                        
                        let specValue = 'N/A';
                        if (item) {
                          const specs = parseSpecifications(item.specifications);
                          const spec = specs.find(s => {
                            if (s.name === specKey) return true;
                            return Object.keys(s).includes(specKey);
                          });
                          
                          if (spec) {
                            specValue = spec.name ? spec.value : spec[specKey];
                          }
                        }
                        
                        return (
                          <td key={vendor._id} className="py-2 px-3 text-sm text-gray-500 border-r">
                            {specValue}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
        
        {getComparisonData().length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No comparison data available
          </div>
        )}
      </div>
    </div>
  </div>
)}



{/* Windows List Popup */}
{/* {showWindowListPopup && selectedWindowItem && (
  <>
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowWindowListPopup(false)}></div>
    
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-xl z-50 rounded-t-3xl border-t border-l border-r border-gray-300 max-w-md mx-auto">
      <div className="w-16 h-1.5 bg-gray-300 rounded-full mx-auto mt-3 mb-4"></div>
      
      <div className="flex justify-between items-center px-5 pb-3">
        <h3 className="text-lg font-bold text-gray-800">
          {selectedWindowItem?.application_areas?.area_name}
          <span className="text-red-500 ml-2">
            ({selectedWindowItem?.application_areas?.count})
          </span>
        </h3>
        <button
          onClick={() => setShowWindowListPopup(false)}
          className="text-gray-500 hover:text-red-500 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <div className="h-px bg-gray-200 w-full"></div>
      
      <div className="mt-4 ml-4">
        <p className="text-lg text-black font-semibold">{selectedWindowItem?.item_name || selectedWindowItem?.product_name}</p>
      </div>
      
      <div className="flex overflow-x-auto border-b border-gray-200 mt-4 pb-1">
        {(() => {
          const unitNumbers = [...new Set(selectedWindowItem?.applied_areas?.map(item => item.unit_no))];
          
          return unitNumbers.map(unitNo => (
            <button
              key={unitNo}
              onClick={() => setActiveUnitTab(unitNo)}
              className={`flex-shrink-0 py-2 px-4 text-center font-medium ${
                activeUnitTab === unitNo 
                  ? 'text-red-600 border-b-2 border-red-600' 
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Unit {unitNo || "N/A"}
            </button>
          ));
        })()}
      </div>
      
      <div className="max-h-[50vh] overflow-y-auto p-4">
        {(() => {
          const windowsInSelectedUnit = selectedWindowItem?.applied_areas?.filter(
            window => window.unit_no === activeUnitTab
          );
          
          if (!windowsInSelectedUnit || windowsInSelectedUnit.length === 0) {
            return (
              <div className="text-center py-6 text-gray-500">No windows found for this unit</div>
            );
          }
          
          return (
            <div>
            
              <div className="ml-2">
                {windowsInSelectedUnit.map((window, index) => (
                  <div key={index} className="py-2 border-b border-gray-100 last:border-b-0">
                    <div className="flex items-center">
                      <span className="text-green-500 mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                      </span>
                      
                      <div className="font-medium text-gray-800">
                        {window.room_name} - <span className="text-black font-semibold">{window.asset_count || 0} Windows</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  </>
)} */}





{showSaveConfirmation && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-center z-50">
    <div className="bg-white rounded-t-xl shadow-xl p-6 w-full max-w-md">
      {/* Handle/indicator at top for visual cue */}
      <div className="w-16 h-1 bg-gray-300 rounded-full mx-auto mb-4"></div>
      
      <h3 className="text-lg font-semibold text-gray-900 mb-5 text-center">
        Would you like to save the changes made to this quote?
      </h3>
      
      <div className="flex justify-center gap-4">
        <button
          onClick={() => setShowSaveConfirmation(false)}
          className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium w-1/3"
        >
          No
        </button>
        <button
          onClick={() => {
            setShowSaveConfirmation(false);
            handleConfirmedSave();
          }}
          className="px-6 py-3 bg-[#EA011F] text-white rounded-lg hover:bg-red-700 transition-colors font-medium w-1/3"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
)}




<div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 flex justify-between items-center"> {/* Floating tab */}
        <div>
          <p className="text-lg font-bold">Total Price</p>
          <p className='text-lg text-[#14A311]'>₹{Number(updatedSampleData.total).toLocaleString('en-IN')} /-</p>
        </div>
        <div className="flex flex-col"> {/* Buttons in column format */}
          <button onClick= {handleSaveQuote} 
          className="rounded-lg bg-red-500 tex-xl text-white font-bold   py-2 px-10 rounded mb-2">
            Save
          </button>
{/*           <button className="rounded-lg bg-red-500 text-white border border-[#C20C0C] py-1 px-2 rounded">
            Cancel
          </button> */}
        </div>
        </div>


<WindowListPopup 
  isOpen={showWindowListPopup}
  onClose={() => setShowWindowListPopup(false)}
  selectedWindowItem={selectedWindowItem}
/>

        
     
    </div>
  );
}

export default WindowsCustomize;